export const ROUTES = {
    inquires: '/inquiries',
    userManagement: '/userManagement',
    purchases: '/purchases',
    notifications: '/notifications',
    bonusSettlements: {
        overview: '/bonus-settlements',
        detail: '/bonus-settlements/:id',
    },
    notFound: '/not-found',
};
